__turbopack_context__.v({
  "active": "SwatchGroup-module__gKMUfG__active",
  "button": "SwatchGroup-module__gKMUfG__button",
  "disabled": "SwatchGroup-module__gKMUfG__disabled",
  "label": "SwatchGroup-module__gKMUfG__label",
  "li": "SwatchGroup-module__gKMUfG__li",
  "main": "SwatchGroup-module__gKMUfG__main",
  "sub": "SwatchGroup-module__gKMUfG__sub",
  "ul": "SwatchGroup-module__gKMUfG__ul",
  "wrapper": "SwatchGroup-module__gKMUfG__wrapper",
});
